import { useMemo } from 'react';

import { FeatureConfig, FeaturePaywallProps } from '#/service/config';

import { useConfig } from './useConfig';

export const usePaywallConfig = ():
  | FeatureConfig<FeaturePaywallProps>
  | undefined => {
  const { features } = useConfig();

  // Get the first enabled paywall feature config
  return useMemo(() => {
    // if the Core config has `purchase.inApp` disabled, we ignore the S3 `paywall` feature config
    if (!features.purchase?.inApp?.enabled) {
      return undefined;
    }

    const paywallConfigs = features?.paywall || [];

    return paywallConfigs.filter((paywall) => paywall.enabled)[0];
  }, [features]);
};
